import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.5 16.5V1.5L16.5 9.00003L1.5 16.5ZM3 8.25V3.92706L13.1459 9.00002L3 14.073V9.75H7.5V8.25H3Z",
		fill: "currentColor"
	})
});
export default SvgSend;
